<template>
  <div>
    <v-container v-if="success">
      <h4>Contact request received successfully someone from our team will reach out to you shortly.</h4>
    </v-container>
    <v-container v-else>
      <h3>Most questions about our services can be answered in our <a href="https://retitlesanddeeds.com/faq/">FAQ</a>.  Still have additional questions?  Contact us below.</h3>
      <v-form ref="contactRequestForm" v-model="contactRequestFormValid" lazy-validation @submit.prevent="submitForm">
        <h2 class="pb-3">Contact Form</h2>
        <v-text-field label="Email" v-model="form.email" dense outlined v-if="!isAuthenticated" :rules="rules.email"></v-text-field>
        <v-select label="Subject" v-model="form.subject" :items="subjects" dense outlined :rules="rules.subject"></v-select>
        <v-text-field label="Order Number" dense outlined v-if="form.subject == 'Status of an already placed order'" v-model="form.orderNumber" :rules="rules.orderNumber"></v-text-field>
        <v-textarea label="Details" outlined v-model="form.details" :rules="rules.details"></v-textarea>
        <v-row>
          <v-col class="text-right"><v-btn color="primary" type="submit" :disabled="submitted">Submit</v-btn></v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {placeContactRequest} from '@/services/api/contact'
import {
  fieldRequired,
  maxLength,
  validEmail,
  selectionRequired,
} from "@/form-rules/index";

export default { 
  data() {
    return {
      subjects: [
        "General questions about our services",
        "Status of an already placed order",
        "Other"
      ],
      form: {
        email: '',
        subject: '',
        orderNumber: '',
        details: '',
      },
      rules: {
        email: [fieldRequired(), maxLength(255), validEmail()],
        subject: [selectionRequired()],
        orderNumber: [fieldRequired(), maxLength(255)],
        details: [fieldRequired()],
      },
      contactRequestFormValid: null,
      submitted: false,
      success: false,
    }
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  methods: {
    submitForm() {
      if (this.isAuthenticated) {
        this.form.email = this.$store.state.auth.user.email
      }
      const formValid = this.$refs.contactRequestForm.validate();
      if (formValid) {
        this.submitted = false;
        placeContactRequest(this.form)
        .then(() => {
          this.success = true
        })
        .catch((e) => {
          this.errors = e
          this.submitted = true
        })
      }
    }
  }
}
</script>

<style>

</style>